import { useState } from "react";

const VideoComponent = ({ className, src, IGStory, onClick }) => {
  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    !error && (
      <video
        autoPlay={IGStory ? false : true}
        className={className}
        controls={IGStory ? false : true}
        style={{
          visibility: isLoaded ? "visible" : "hidden",
          height: isLoaded ? "auto" : 0,
        }}
        onClick={onClick}
        onError={() => setError(true)}
        onLoadedData={() => setIsLoaded(true)}
      >
        <source src={src} />
      </video>
    )
  );
};

export default VideoComponent;
